/**
 * Import Row Selection Mixin
 * Handles row selection state and logic for imports
 */
export default {
    data() {
        return {
            // Row selection state
            selected_rows: [],
            select_all: false,
        };
    },

    computed: {
        /**
         * Get importable rows (rows that can be selected for import)
         */
        importable_rows() {
            if (!this.preview_data || !this.preview_data.preview_rows) {
                return [];
            }
            return this.preview_data.preview_rows.filter(row => row.will_be_imported);
        },

        /**
         * Check if all importable rows are selected
         */
        all_rows_selected() {
            if (this.importable_rows.length === 0) {
                return false;
            }
            return this.selected_rows.length === this.importable_rows.length;
        },


    },

    methods: {
        /**
         * Initialize row selection with all importable rows selected by default
         */
        initializeRowSelection() {
            if (this.preview_data && this.preview_data.preview_rows) {
                // Only select rows that can be imported
                this.selected_rows = this.preview_data.preview_rows.filter(row => row.will_be_imported);
                this.updateSelectAllState();
            }
        },

        /**
         * Toggle selection for a specific row (only if it can be imported)
         */
        toggleRowSelection(item) {
            // Only allow selection if the row can be imported
            if (!item.will_be_imported) {
                return;
            }

            const index = this.selected_rows.findIndex(row => row.row_number === item.row_number);
            if (index > -1) {
                this.selected_rows.splice(index, 1);
            } else {
                this.selected_rows.push(item);
            }
            this.updateSelectAllState();
        },

        /**
         * Toggle select all/none (only importable rows)
         */
        toggleSelectAll() {
            if (this.select_all) {
                this.selected_rows = [];
            } else {
                // Only select rows that can be imported
                this.selected_rows = this.preview_data.preview_rows.filter(row => row.will_be_imported);
            }
            this.updateSelectAllState();
        },

        /**
         * Update the select all state based on current selection
         */
        updateSelectAllState() {
            this.select_all = this.all_rows_selected;
        },



        /**
         * Get selected row numbers for API calls
         */
        getSelectedRowNumbers() {
            return this.selected_rows.map(row => row.row_number);
        }
    },

    watch: {
        /**
         * Initialize row selection when preview data is loaded
         */
        preview_data: {
            handler(newData) {
                if (newData && newData.preview_rows) {
                    this.initializeRowSelection();
                }
            },
            immediate: true
        }
    }
};
